import { Component, Input, computed, signal } from '@angular/core';
import { SpacerWidget, Theme } from '../../models/reader-document';

@Component({
  selector: 'wr-spacer-widget',
  standalone: true,
  template: `
    <div
      [style.background]="background()"
      [style.height]="(widget()?.spacing ?? 0) + 8 + 'px'"
    >
    </div>
  `,
})
export class SpacerWidgetComponent {
  private widgetSig = signal<SpacerWidget | null>(null);
  private themeSig = signal<Theme | null>(null);


  @Input() set json(value: SpacerWidget) {
    this.widgetSig.set(value);
  }

  @Input() set theme(value: Theme | undefined) {
    this.themeSig.set(value ?? null);
  }

  widget = computed(() => this.widgetSig());

  // use darkColors for test
  private colors = computed(() => this.themeSig()?.darkColors);

  background = computed(
    () =>
      this.widget()?.style?.['background'] ??
      //this.colors()?.background ??
      'transparent',
  );

}